export const common = {
    yes: 'OK',
    no: 'CLOSE',
    login: 'Login',
    welcome: 'Welcome',
    signOut: 'Logout',
    faq: 'FAQ',
    pleaseSelect: 'Please select',
    operatingManual: 'Operating Manual',
    noData: 'No Data',
    filters: 'Filters',
    filter: 'Filter',
    apply: 'Apply',
    clearAll: 'Clear All',
    showAll: 'Show All',
    confirmModalTitle: 'Confirm',
    selectAll: 'Select all',
    xItemSelected: 'items selected',
    allSelected: 'All selected',
    relevent: 'Relevent',
    Inrelevent: 'Inrelevent',
    cancel: 'cancel',
    send: 'send',
    warningMsg: {
        inputRequired: 'Please enter.',
        selectRequired: 'Please select.',
        invalidEmail: 'Invalid email.'
    },
    company: 'COMPANY',
    theme: 'THEME',
    country: 'COUNTRY',

    pageTitle: 'Intelligent Business Analytics',
    filterCompany: 'SELECT a COMPANY',
    filterTheme: 'SELECT a THEME',
    relatedTheme: 'RELATED THEMES',
    filterCategory: 'SELECT a CATEGORY',
    filterCountry: 'SELECT a COUNTRY',
    search: 'SEARCH',
    selectLang: 'ENGLISH',

    // ヘッダーのモード切替
    userMode: 'User Mode',
    adminMode: 'Admin Mode',
    analysisMode: 'Consulting Analysis Upload',

    // ヘッダーのヘルプメニュー
    aboutTheService: 'About the service',
    howToUse: 'How to use',
    glossary: 'Glossary',

    // request/index.js
    doubleLogin:
        'Duplicate login detected, forcing logout. Please make sure you are not logged in on any other device, and contact the administrator immediately in case you are not.'
}
